<div class="grid-container padding-y-4">
  <div class="grid-row">
    <legend class="usa-legend usa-legend--large">Please select one of the below user accounts to continue to TMSS 2.0 application.</legend>
  </div>
  <ag-grid-angular class="ag-theme-alpine margin-top-2"
                   [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                   [defaultColDef]="defaultColDef"
                   [rowData]="rowData"
                   [pagination]="true"
                   [gridOptions]="gridOptions"
                   (gridReady)="onGridReady($event)"
                   [columnDefs]="columnDefs"
                   [rowClassRules] = "rowClassRules"
                   [getRowHeight]="getRowHeight"
                   ag-grid-resize>
  </ag-grid-angular>
</div>

